/******/ (() => {
  // webpackBootstrap
  var __webpack_exports__ = {};
  window.PXUTheme.jsFeaturedCollection = {
    init: function ($section) {
      // Add settings from schema to current object
      window.PXUTheme.jsFeaturedCollection = $.extend(
        this,
        window.PXUTheme.getSectionData($section)
      );

      if (this.collection_layout == "slider") {
        this.createSlider(".slider-gallery--desktop");
      }

      if (this.collection_layout_mobile == "slider") {
        this.createSlider(".slider-gallery--mobile");
      }
    },
    createSlider: function (el) {
      const slider = $(el);

      let config = {
        lazyLoad: 2,
        freeScroll: true,
        imagesLoaded: true,
        draggable: true,
        cellAlign: "left",
        wrapAround: true,
        pageDots: false,
        contain: true,
        prevNextButtons: this.products_limit > this.products_per ? true : false,
        initialIndex: 0,
        arrowShape: arrowShape
      };

      const calcluateArrowsPosition = () => {
        const sliders = document.querySelectorAll(
          ".featured-collection--slider"
        );
        sliders.forEach((slider) => {
          const image = slider.querySelector(
            ".image__container.product__imageContainer"
          );
          if (!image) {
            console.error("Image couldn't be found");
            return;
          }
          //fixking flickity button height to 44px, if needed this can be dynamical
          const halfImage = image.offsetHeight / 2;
          const arrows = slider.querySelectorAll(".flickity-button");
          arrows.forEach((arrow) => {
            arrow.style.top = `${halfImage}px`;
          });
        });
      };

      if (matchMedia("screen and (max-width: 768px)").matches) {
        config.cellAlign = "left";
        config.arrowShape = {
          x0: 10,
          x1: 60,
          y1: 50,
          x2: 60,
          y2: 45,
          x3: 15,
        };
        calcluateArrowsPosition();
      }

      $(slider).flickity(config);

      $(slider).on("settle.flickity", () => $(slider).flickity("resize"));
    },
    unload: function ($section) {
      let $slider = $section.find(".flickity-enabled");
      $slider.flickity("destroy");
    },
  };

  /******/
})();
